import * as yup from 'yup';

export const AddUserFormInputs = yup
  .object()
  .shape({
    name: yup.string().required(),
    email: yup.string().email().required(),
    extension: yup.string(),
  })
  .required();

export type AddUserFormInputs = yup.InferType<typeof AddUserFormInputs>;
